import { Grid, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import zIndex from '@mui/material/styles/zIndex'
import i18n from 'i18n'

export const PopupSectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.625rem',
  fontWeight: 400,
  textTransform: 'uppercase',
  padding: theme.spacing(1.5, 0, 1, 0)
}))

export const PopupSectionContent = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderBottom: '1px solid',
  borderColor: theme.palette.border.primary
}))

export const PopupSectionRow = styled(Grid)(({ color, theme }) => ({
  width: '100%',
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  cursor: 'pointer',
  justifyContent: 'space-between',
  fontSize: 14,
  color: theme.palette.text.primary,
  padding: theme.spacing(1, 0),

  '& > div': {
    display: 'flex',
    alignItems: 'center'
  },

  '&[data-onlytitle="true"]': {
    '& > div': {
      width: '100%'
    },
    '& span[data-content="title"]': {
      width: '100%',
      fontWeight: 400
    }
  },

  '& span[data-content="icon"]': {
    height: 16,
    fontSize: '0.625rem',
    minWidth: '42px',
    fontWeight: 400,
    color: theme.palette.input.placeholder,
    margin: theme.spacing(0, 3, 0, 0)
  },
  '& span[data-content="icon-small"]': {
    height: 12,
    fontSize: '0.625rem',
    minWidth: '42px',
    fontWeight: 400,
    color: theme.palette.input.placeholder,
    margin: theme.spacing(0, 3, 0, 0)
  },
  '& span[data-content="icon-regular"]': {
    height: 20,
    fontSize: '0.625rem',
    width: 20,
    maxWidth: 20,
    fontWeight: 400,
    color: theme.palette.input.placeholder,
    margin: theme.spacing(
      0,
      i18n.dir() === 'ltr' ? 3 : 0,
      0,
      i18n.dir() === 'rtl' ? 3 : 0
    )
  },
  '& span[data-content="icon-big"]': {
    height: 24,
    fontSize: '0.625rem',
    width: 24,
    maxWidth: 24,
    fontWeight: 400,
    color: theme.palette.input.placeholder,
    margin: theme.spacing(
      0,
      i18n.dir() === 'ltr' ? 3 : 0,
      0,
      i18n.dir() === 'rtl' ? 3 : 0
    )
  },
  '& span[data-content="action"]': {
    cursor: 'pointer',
    color: color
  }
}))

export const PopupSection = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(0, 5),
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  color: 'rgb(129 129 129)',

  '&:first-of-type': {
    [`${PopupSectionContent}`]: {
      paddingTop: 0
    }
  },

  '&:last-child': {
    [`${PopupSectionContent}`]: {
      borderBottom: 0,
      paddingBottom: 0
    }
  }
}))
